function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.027 16.296c.055.293.19.573.408.8l11.128 11.602a.962.962 0 001.401 0l.746-.778a1.064 1.064 0 000-1.46L11.678 16 21.71 5.54a1.064 1.064 0 000-1.46l-.746-.777a.962.962 0 00-1.4 0L8.434 14.904a1.591 1.591 0 00-.408 1.392z",
  fill: "currentColor"
})));